export const tableKey = (label) => {
  const m = String(label || '').match(/(\d+)/);
  return m ? m[1] : String(label || '').trim();
};

export const isLate = (g) => !!(g.reply_by_override || g.late_invite_at || g.reopened_at);

export const plusOneComing = (g) => {
  if (g.rsvp === 'No' || !g.plusOne) return false;
  return g.plusOneComing == null ? true : !!g.plusOneComing;
};

export const plusOneLabel = (g) => (g.plusOneName || '').trim() || `Guest of ${(g.name || 'guest').split(' ')[0]}`;

// Seats a guest takes up and the names to print on the table.
export const seatNames = (g) => [g.name, ...(plusOneComing(g) ? [plusOneLabel(g)] : [])];

export const matchesQuery = (g, q) => {
  const words = q.toLowerCase().trim().split(/\s+/).filter(Boolean);
  if (!words.length) return true;
  const hay = `${g.name || ''} ${g.plusOneName || ''}`.toLowerCase();
  return words.every((w) => hay.includes(w));
};

export const SHAPES = {
  round: { label: 'Round', defaultSeats: 8 },
  rect: { label: 'Rectangle', defaultSeats: 10 },
  square: { label: 'Square', defaultSeats: 8 },
  sweetheart: { label: 'Sweetheart', defaultSeats: 2 },
};

// Size in "units" (1 unit = 1% of room width).
export const tableSize = (t) => {
  const s = Number(t.seats) || 8;
  const turned = Number(t.rotation) === 90;
  let w; let h;
  if (t.shape === 'rect') { w = Math.max(16, s * 2.2); h = 9; }
  else if (t.shape === 'square') { w = Math.max(12, 7 + s * 0.8); h = w; }
  else if (t.shape === 'sweetheart') { w = 15; h = 7; }
  else { w = Math.max(12, 7 + s * 0.9); h = w; }
  return turned ? { w: h, h: w } : { w, h };
};

export const FEATURES = {
  dance_floor: { label: 'Dance floor', w: 20, h: 24, color: '#EDE7F6', border: '#B39DDB', ink: '#5E35B1' },
  dj: { label: 'DJ / Band', w: 12, h: 9, color: '#E3F2FD', border: '#90CAF9', ink: '#1565C0' },
  bar: { label: 'Bar', w: 16, h: 8, color: '#FFF3E0', border: '#FFCC80', ink: '#E65100' },
  cake: { label: 'Cake table', w: 8, h: 10, color: '#FCE4EC', border: '#F48FB1', ink: '#AD1457' },
  buffet: { label: 'Buffet', w: 20, h: 8, color: '#F1F8E9', border: '#C5E1A5', ink: '#558B2F' },
  entrance: { label: 'Entrance', w: 10, h: 5, color: '#ECEFF1', border: '#B0BEC5', ink: '#37474F' },
  gifts: { label: 'Gift table', w: 9, h: 8, color: '#FFF8E1', border: '#FFE082', ink: '#B45309' },
  indoor: { label: 'Indoor', w: 55, h: 70, color: 'rgba(251,247,242,0.55)', border: '#B8896C', ink: '#7B4A1A', area: true },
  outdoor: { label: 'Outdoor patio', w: 40, h: 70, color: 'rgba(232,245,233,0.55)', border: '#81C784', ink: '#2E7D32', area: true },
};

// First grid spot that isn't on top of an existing table or feature.
export const freeSpot = (items) => {
  for (let y = 14; y <= 86; y += 12) {
    for (let x = 10; x <= 90; x += 10) {
      if (items.every((p) => Math.hypot(p.x - x, (p.y - y) * 0.625) >= 9)) return { x, y };
    }
  }
  return { x: 50, y: 50 };
};

const SUFFIXES = ['jr', 'jr.', 'sr', 'sr.', 'ii', 'iii', 'iv'];
// "Becky Ingram" -> { display: 'Ingram, Becky', key: 'ingram becky' }
export const lastFirst = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length < 2) return { display: parts.join(' '), key: parts.join(' ').toLowerCase() };
  let suffix = '';
  if (parts.length > 2 && SUFFIXES.includes(parts[parts.length - 1].toLowerCase())) suffix = ` ${parts.pop()}`;
  const last = parts.pop();
  return { display: `${last}${suffix}, ${parts.join(' ')}`, key: `${last} ${parts.join(' ')}`.toLowerCase() };
};
